<script>
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import Logo from '@/Components/Logo.svelte';
	// Constants
	import config from '@/config.js';

	let errors = null;
	let success = null;

	let sending = false;
	let values = {
		email: ''
	};

	function handleSubmit() {
		sending = true;
		AuthUserStore.forgot(values)
			.then((response) => {
				errors = null;
				success = response.meta.message;
				console.dir(response);
			})
			.catch((error) => {
				errors = error;
			})
			.finally(() => (sending = false));
	}
</script>

<Helmet title="Forgot your password" />
<div class="flex items-center justify-center min-h-screen p-6 bg-brand-black">
	<div class="w-full max-w-md">
		{#if config.BRAND == 'socialbet'}
			<img
				src="/images/logo.png"
				class="block max-w-xs mx-auto h-10"
				alt={config.BRAND_NAME}
				height="32px"
				width="126px"
			/>
		{:else}
			<div class="w-auto h-20 mx-auto block px-16">
				<Logo />
			</div>
		{/if}

		<form on:submit|preventDefault={handleSubmit} class="mt-8 overflow-hidden bg-white rounded-lg shadow-xl">
			<div class="px-10 py-8">
				<h1 class="text-3xl font-bold text-center">Forgot your password?</h1>
				<div class="w-24 mx-auto mt-6 border-b-2" />
				<div class="my-4 text-center text-sm">
					<p>Put in your email and we will email you a link so you can reset your password!</p>
				</div>

				<TextInput
					className="mt-4"
					label="Email"
					name="email"
					type="email"
					errors={errors && errors.email}
					bind:value={values.email}
				/>
				{#if errors && errors.error}
					<div class="-mb-2 pt-3 text-center form-error">{errors.error}</div>
				{/if}
				{#if success}
					<div class="-mb-2 pt-3 text-center form-success">{success}</div>
				{/if}
			</div>

			<div class="flex items-center justify-end px-10 py-5 bg-gray-100 border-t border-gray-200">
				<LoadingButton
					type="submit"
					loading={sending}
					className="px-6 py-3 rounded bg-secondary text-white text-sm font-bold
          whitespace-nowrap hover:bg-dark"
				>
					Request password reset
				</LoadingButton>
			</div>
		</form>
	</div>
</div>
